<template>
  <v-card class="ts-deploy">
    <label>https://tennis-system.s3.ap-northeast-2.amazonaws.com/dist/</label>
    <v-row no-gutters align="center">
      <v-file-input
          v-model="files"
          color="deep-purple accent-4"
          counter
          label="File input"
          multiple
          placeholder="Select your files"
          prepend-icon="mdi-paperclip"
          outlined
          :show-size="1000"
      >
        <template v-slot:selection="{ index, text }">
          <v-chip
              v-if="index < 2"
              color="deep-purple accent-4"
              dark
              label
              small
          >
            {{ text }}
          </v-chip>

          <span
              v-else-if="index === 2"
              class="overline grey--text text--darken-3 mx-2"
          >
          +{{ files.length - 2 }} File(s)
        </span>
        </template>
      </v-file-input>
      <v-btn @click="readFile">Deploy</v-btn>
    </v-row>
    <v-row>
      <v-col>
        <v-progress-linear v-model="progress"></v-progress-linear>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col>
        <v-btn class="col-12" @click="sendQuery()">Query</v-btn>
        <v-textarea solo v-model="query" @keyup.native="sendQuery"></v-textarea>
      </v-col>
      <v-col>
        <v-textarea v-model="result" readonly></v-textarea>
      </v-col>
    </v-row>
    <v-row no-gutters style="max-height:300px; overflow-y:auto;">
      <v-list dense>
        <v-list-item v-for="(_history,i) in history.split('\n')" :key="i"
                     @click="query = _history"
                     @dblclick="() => {query = _history; sendQuery()}"
        >
          <span>{{_history}}</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="history = history.split('\n').filter((txt,j) => i !== j).join('\n')"><v-icon>mdi-close</v-icon></v-btn>
        </v-list-item>
      </v-list>
    </v-row>
  </v-card>
</template>

<style scoped>
  .ts-deploy{
    padding: 15px;
  }
</style>

<script>
  import request from '@/plugins/axios'
  import { rawQuery } from "@/api/db";
export default {
  name: "Deploy",
  data: () => ({
    query: '',
    result: '',
    history: localStorage.getItem('deploy.history') || '',
    files: null,
    progress: 0,
  }),
  mounted() {
    this.$emit('update:picker',false)
  },
  watch: {
    history(val){
      localStorage.setItem('deploy.history',val)
    }
  },
  methods: {
    setHistory(query){
      const historySplit = this.history.split('\n')
      historySplit.splice(0,0,query.trim())
      this.history = [...new Set(historySplit.map(line => line.trim()).filter(line => line))].join('\n')
    },
    sendQuery(e){
      if(e === undefined || e.keyCode === 13 && e.ctrlKey){
        this.setHistory(this.query)
        this.result = ''
        rawQuery(this.query).then((result)=>{
          this.result = JSON.stringify(result.data || result).replace(/\\n/g,'\n')
        })
      }

    },
    readFile(){
      const _self = this
      this.files.forEach(file => {
        const fr=new FileReader();
        const targetName = file.name
        const bufferSize = 10 * 1024
        fr.onload= async function(){
          const result = Array.from(new Int8Array(fr.result))
          let i = 0
          await request.post('',{start:true, name: targetName, data:result.slice(i,i- -bufferSize)})
          _self.progress= 0
          for(i += bufferSize; i <= result.length; i += bufferSize){
            _self.progress= i * 100/ Math.max(result.length,bufferSize)
            await request.post('',{name: targetName, data:result.slice(i,i- -bufferSize)})
          }
          _self.progress= 100
          await _self.$alert(`${targetName} 업로드 완료`)
        }
        fr.readAsArrayBuffer(file);
      })

    }
  }
}
</script>
